export const BULLETIN_TAGS = ["系統維護", "最新消息", "新功能上線"] as const;

export type BulletinTag = (typeof BULLETIN_TAGS)[number];